import {AdminAxios} from "../../common/Axios";

const isInit = false;

const ACTION_URL = '/adver/setting'
const BUDGET_EVENT = '/budget'
const BUDGET_LIST = '/budget/list'

/**
 * 이벤트 예산 관리 광고주 리스트
 * @param keyword
 * @returns {Promise<null>}
 */
export async function selAdverBudgetEventList(keyword) {
  let returnVal = null;
  if (isInit) {
    return {
      totalCount: 1,
      userDtos: [{
        userId: "1",//          UUID.
        username: "ytkim_advert",//        광고주 id.
        adverName: "용태팡",//       광고주 명.
        managerName: "김용태",//     담당자 명.
        lastModifiedAt: "20250810",//  최근 수정 날짜
        targetingBudgetDtos: [
          {
            targetingBudgetId: "1", //                이벤트 단가 id.
            groupName: "타겟팅 예산 그룹1", //              타겟팅 예산 그룹 name.
            shopperMatching: "0", //        쇼퍼 맞춤.
            cartRecommendation: "0", //    카트 추천.
            productRecommendation: "0", // 상품 추천.
            userMatching: "0", //           유저 매치.
            audience: "0", //               오디언스.
            userOptimization: "0", //       유저 최적화.
          }
        ],// 타겟팅 예산 그룹 리스트.
      }]
    }
  }
  await AdminAxios('POST', ACTION_URL + BUDGET_LIST, keyword)
  .then((response) => {
    const { data, statusCode, message } = response;
    if(statusCode === 200) {
      returnVal = data;
    }else{
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 이벤트 예산 관리 상세 리스트
 * @param username
 * @returns {Promise<null>}
 */
export async function selBudgetEventList(userId) {
  let returnVal = null;
  if (isInit) {
    return {
      userId: "1",//          UUID.
      username: "ytkim_advert",//        광고주 id.
      adverName: "용태팡",//       광고주 명.
      managerName: "김용태",//     담당자 명.
      lastModifiedAt: "2025-08-10",//  최근 수정 날짜
      targetingBudgetDtos: [
        {
          targetingBudgetId: "1", //                이벤트 단가 id.
          groupName: "타겟팅 예산 그룹1", //              타겟팅 예산 그룹 name.
          shopperMatching: "0", //        쇼퍼 맞춤.
          cartRecommendation: "0", //    카트 추천.
          productRecommendation: "0", // 상품 추천.
          userMatching: "0", //           유저 매치.
          audience: "0", //               오디언스.
          userOptimization: "0", //       유저 최적화.
        }
      ],// 타겟팅 예산 그룹 리스트.
    }
  }
  await AdminAxios('GET', ACTION_URL + BUDGET_EVENT + '/' + userId)
  .then((response) => {
    const { data, statusCode, message } = response;
    if(statusCode === 200) {
      returnVal = data;
    }else{
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 이벤트 예산 관리 등록
 * @param budgetEventInfo
 * @returns {Promise<null>}
 */
export async function resistBudgetEvent(budgetEventInfo) {
  let returnVal = null;
  await AdminAxios('POST', ACTION_URL + BUDGET_EVENT, budgetEventInfo)
  .then((response) => {
    const { data, statusCode, message } = response;
    if(statusCode === 200) {
      returnVal = true;
    }else{
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};

/**
 * 이벤트 예산 관리 수정
 * @param budgetEventInfo
 * @returns {Promise<null>}
 */
export async function updateBudgetEvent(budgetEventInfo) {
  let returnVal = null;
  await AdminAxios('PUT', ACTION_URL + BUDGET_EVENT, budgetEventInfo)
  .then((response) => {
    const { data, statusCode, message } = response;
    if(statusCode === 200) {
      returnVal = true;
    }else{
      returnVal = null;
    }
  }).catch((e) => returnVal = false)
  return returnVal;
};


